import PropTypes from 'prop-types'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../stories/atoms/button/constants'
import AlertComponent from '../stories/molecules/alerts'
import { alertVariantComponentOptions } from '../stories/molecules/alerts/constants'
import { useIntl } from 'react-intl'

const DeleteFolderAlert = ({
  onClose = () => {},
  onDelete = () => {},
  onDeleteLoading = false,
  isOpen = false,
  title = null,
  description = null
}) => {
  const { formatMessage } = useIntl()

  const defineTitle =
    title ?? formatMessage({ id: 'deleteFolder' }, { count: 1 })
  const defineDescription =
    description ??
    formatMessage({ id: 'projectMenu_delete_folder_description' })

  return (
    <AlertComponent
      isOpen={isOpen}
      variant={alertVariantComponentOptions.DANGER}
      title={defineTitle}
      description={defineDescription}
      size="500px"
      activeOverlay
      actionButtons={[
        {
          variant: buttonVariantOptions['SECONDARY-HOLLOW'],
          onClick: onClose,
          children: formatMessage({ id: 'cancel' }),
          size: buttonSizeOptions.LARGE,
          fullWidth: true
        },
        {
          variant: buttonVariantOptions['PRIMARY-DESTRUCTIVE'],
          onClick: onDelete,
          children: formatMessage({ id: 'delete1' }),
          size: buttonSizeOptions.LARGE,
          isLoading: onDeleteLoading,
          fullWidth: true
        }
      ]}
    />
  )
}

DeleteFolderAlert.propTypes = {
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string
}

export default DeleteFolderAlert
